import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { analytics } from '@heycatch/sdk';
import "./index.css";
import App from "./App";

// HeyCatch analytics — module scope, before render
analytics.init({
  projectKey: process.env.REACT_APP_HEYCATCH_KEY,
  install: {
    framework: 'react',
    frameworkVersion: '18',
    agent: 'other',
  },
});

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: window.location.hostname === 'clicdoc.com.br' ? 'production' : 'preview',
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{padding:'2rem',textAlign:'center'}}>
      <h2>Algo deu errado</h2><p>Tente recarregar a página.</p>
    </div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA push notifications (iOS + Android + Desktop)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.log('[SW] Registered:', reg.scope),
      (err) => console.warn('[SW] Registration failed:', err)
    );
  });
}
